import { WidgetRegistry } from "@Widgets/types";

import devToolsWidgetRegistry from "@Libs/DevTools/config/devToolsWidgetRegistry";
import appWidgetRegistry from "@modules/App/config/appWidgetRegistry";
import serviceOffersWidgetRegistry from "@modules/ServiceAssignment/config/serviceOffersWidgetRegistry";
import serviceRequestWidgetRegistry from "@modules/ServiceRequest/config/serviceRequestWidgetRegistry";
import confirmationEmailTopWidgetRegistry from "@modules/Authentication/config/confirmationEmailTopWidgetRegistry";

const registry: WidgetRegistry = {
  ...devToolsWidgetRegistry,
  ...appWidgetRegistry,
  ...serviceOffersWidgetRegistry,
  ...serviceRequestWidgetRegistry,
  ...confirmationEmailTopWidgetRegistry,
};

export default registry;
